import React, { useEffect, useState } from "react";
import Header from "./GeneratalComponents/TopHeader";
import Footer from "./GeneratalComponents/Footer";
import { encryptId, loginapi } from "../../services/apiService";
import { useNavigate, useLocation } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from "react-toastify";
import { oneKlicks, sendSMS } from "../../SDK/oneclick";
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import { Link } from "react-router-dom";
import { debugLog } from "../../utils/debug";
import { useAuth } from "../../context/AuthContext";

const FrontendLayout = ({ children }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const { login, isLoggedIn } = useAuth();
    const [loginbutton, setLoginbutton] = useState(false);
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [user, setUser] = useState(null);
    const [showOtpForm, setShowOtpForm] = useState(false);
    const [otp, setOtp] = useState("");
    const [tempUserData, setTempUserData] = useState(null);
    const [loginMethod, setLoginMethod] = useState('email');
    const [resendOtpCount, setResendOtpCount] = useState(0);
    const [canResendOtp, setCanResendOtp] = useState(false);
    const [error, setError] = useState("");

    const [isMobile, setIsMobile] = useState(window.innerWidth < 700);

    console.log("FrontendLayout loginbutton :", loginbutton);

    useEffect(() => {
        if (loginbutton) {
            setLoginMethod('email');
        }
    }, [loginbutton]);

    // Reset login modal state when user is already logged in
    useEffect(() => {
        if (isLoggedIn && loginbutton) {
            setLoginbutton(false);
        }
    }, [isLoggedIn, loginbutton]);

    useEffect(() => {
        let timer;
        if (resendOtpCount > 0) {
            timer = setInterval(() => {
                setResendOtpCount((prevCount) => {
                    if (prevCount <= 1) {
                        setCanResendOtp(true);
                        return 0;
                    }
                    return prevCount - 1;
                });
            }, 1000);
        }
        return () => {
            if (timer) clearInterval(timer);
        };

    }, [resendOtpCount]);

    useEffect(() => {
        const handleResize = () => {
            const width = window.innerWidth;
            setIsMobile(width < 700);
        };

        // Initial check
        handleResize();

        // Add event listener
        window.addEventListener('resize', handleResize);

        // Cleanup
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);


    const handleLogin = async (e) => {
        e.preventDefault();
        try {
            const loginresponce = await oneKlicks.read("", "users", { email: email, pass: password }, "id ASC", "", "", "");
            if (loginresponce.success && loginresponce.data && loginresponce.data.length > 0) {
                const user = loginresponce.data[0];
                localStorage.setItem("userData", JSON.stringify(user));
                localStorage.setItem("token", user.token);
                setLoginbutton(false);
                navigate("/");
            } else {
                setError("Invalid email or password");
            }
        } catch (error) {
            setError("Login failed. Please try again.");
        }
    };

    const handleTwilioMessage = async (phoneNumber, message) => {
        try {
            const response = await sendSMS(phoneNumber, message);
            if (!response.success) {
                throw new Error(response.message || "Failed to send message");
            }
        } catch (error) {
            setError("Failed to send message. Please try again.");
        }
    };

    const loginbtn = async (event) => {
        event.preventDefault();
        console.log("Login button run");


        try {
            if (loginMethod === 'email') {
                if (email === "" || password === "") {
                    toast.error("Please enter email and password");
                    return;
                }
                if (!email.includes("@") || !email.includes(".")) {
                    toast.error("Please enter a valid email");
                    return;
                }
                if (password.length < 8) {
                    toast.error("Password must be at least 8 characters long");
                    return;
                }
                const loginresponce = await loginapi(email, password);
                console.log("Login response:", loginresponce);
                if (loginresponce.data && loginresponce.data.length > 0) {
                    const user = loginresponce.data[0];
                    if (user) {
                        if (user.status === "2") {
                            toast.error("Your account has been deleted. Please contact support.");
                            return;
                        }
                        debugLog('USERID :', user.id);

                        const userData = {
                            id: user.id,
                            email: user.email,
                            user_type: user.user_type || "user",
                            display_name: user.display_name || user.email
                        };

                        // Use the login function from AuthContext
                        const loginSuccess = await login(userData);

                        if (loginSuccess) {
                            toast.success("Login successful!", { autoClose: 2000 });
                            setUser(user);
                            setEmail("");
                            setPassword("");
                            setLoginbutton(false);
                            handleNavigation(userData);
                        } else {
                            toast.error("Login failed. Please try again.");
                        }

                    } else {
                        toast.error("Login failed. Please try again.");
                    }
                } else {
                    toast.error("No user found with these credentials.");
                }
            } else {
                // Phone login logic
                const tableSchema = "";
                const tableName = "users";
                const conditions = {
                    phone: phoneNumber
                };
                const orderBy = "id DESC";
                const phoneLoginResponse = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, "", "", "");

                if (phoneLoginResponse.data.length > 0) {
                    const user = phoneLoginResponse.data[0];
                    const generatedOtp = Math.floor(100000 + Math.random() * 900000); // Generate a random 6-digit OTP



                    try {
                        const body = `Hey! Here's your MeddyList verification code: ${generatedOtp}. Use it to continue. Keep it secure!`;
                        const message = await sendSMS(phoneNumber, body);
                        console.log("Twilio message response:", message);

                        if (message.sid) {
                            // Store OTP in database with expiry
                            const data = {
                                otp: generatedOtp,
                                otp_expiry: new Date(Date.now() + 10 * 60000) // 10 minutes expiry
                            };
                            const condition = {
                                phone: phoneNumber
                            };

                            const storeOtpResponse = await oneKlicks.update(tableSchema, tableName, data, condition);

                            if (storeOtpResponse.success) {
                                setTempUserData({ phone: phoneNumber, id: user.id });
                                setShowOtpForm(true);
                                setResendOtpCount(60);
                                toast.success("OTP sent to your phone number", { autoClose: 3000 });
                            } else {
                                toast.error("Failed to store OTP. Please try again.");
                            }
                        }
                    } catch (twilioError) {
                        console.error("Twilio error:", twilioError);
                        toast.error("Failed to send OTP. Please try again.");
                    }
                } else {
                    try {
                        const tableSchema = "";
                        const tableName = "pharmacies";
                        const conditions = {
                            phone: phoneNumber
                        };
                        const orderBy = "id DESC";
                        const phoneLoginResponse = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, "", "", "");
                        if (phoneLoginResponse.data.length > 0) {
                            const user = phoneLoginResponse.data[0];
                            const generatedOtp = Math.floor(100000 + Math.random() * 900000);

                            try {
                                const body = `Hey! Here's your MeddyList verification code: ${generatedOtp}. Use it to continue. Keep it secure!`;
                                const message = await sendSMS(phoneNumber, body);

                                if (message.sid) {
                                    const data = {
                                        otp: generatedOtp,
                                        otp_expiry: new Date(Date.now() + 10 * 60000)
                                    };
                                    const condition = {
                                        phone: phoneNumber
                                    };

                                    const storeOtpResponse = await oneKlicks.update(tableSchema, tableName, data, condition);

                                    if (storeOtpResponse.success) {
                                        setTempUserData({ phone: phoneNumber, id: user.id });
                                        setShowOtpForm(true);
                                        setResendOtpCount(60);
                                        toast.success("OTP sent to your phone number", { autoClose: 3000 });
                                    } else {
                                        toast.error("Failed to store OTP. Please try again.");
                                    }
                                }
                            } catch (twilioError) {
                                console.error("Twilio error:", twilioError);
                                toast.error("Failed to send OTP. Please try again.");
                            }
                        } else {
                            toast.error("Phone number not found. Please check and try again.");
                        }
                    } catch (error) {
                        console.error("Phone number not found. Please check and try again.");
                        toast.error("Something went wrong. Please try again.");
                    }
                }
            }
        } catch (error) {
            console.error("Login error:", error);
            toast.error("Something went wrong. Please try again.");
        }
    };

    const handleNavigation = (userData) => {
        setTimeout(() => {
            switch (userData.user_type?.toLowerCase()) {
                case "admin":
                    navigate("/admin-dashboard");
                    break;
                case "doctor":
                    navigate(`/doctor/dashboard/${encryptId(userData.id)}`);
                    break;
                case "hospitals":
                    navigate("/hospital/dashboard");
                    break;
                case "patient":
                    navigate("/user-dashboard");
                    break;
                case "regular_users":
                    navigate("/user-dashboard");
                    break;
                case "pharmacy":
                    navigate("/pharmacy/dashboard");
                    break;
                case "user":
                    // Stay on home page - user can access dashboard from header dropdown
                    navigate("/");
                    break;
                case "administrator":
                    navigate("/superadmin/dashboard");
                    break;
                case "staff":
                    navigate("/superadmin/dashboard");
                    break;
                case "editor":
                    navigate("/editor-dashboard");
                    break;
                default:
                    // For unknown roles, stay on home page
                    navigate("/");
                    break;
            }
        }, 1500);
    };

    const verifyOtp = async (event) => {
        event.preventDefault();
        try {
            const tableSchema = "";
            const tableName = "users";
            const conditions = {
                phone: tempUserData.phone,
                otp: otp,
                otp_expiry: new Date() // Check if OTP is not expired
            };

            const verifyResponse = await oneKlicks.read(tableSchema, tableName, conditions, "", "", "", "");

            if (verifyResponse.success && verifyResponse.data.length > 0) {
                const userData = verifyResponse.data[0];
                localStorage.setItem("userData", JSON.stringify(userData));
                setUser(userData);
                setLoginbutton(false);
                setShowOtpForm(false);
                toast.success("Login successful!", { autoClose: 2000 });
                handleNavigation(userData);
            } else {
                const tableSchema = "";
                const tableName = "pharmacies";
                const conditions = {
                    phone: tempUserData.phone
                };
                const orderBy = "id DESC";
                const phoneLoginResponse = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, "", "", "");
                if (phoneLoginResponse.data.length > 0) {
                    const user = phoneLoginResponse.data[0];
                    const generatedOtp = Math.floor(100000 + Math.random() * 900000);
                } else {
                    toast.error("Invalid or expired OTP. Please try again.");
                }
            }
        } catch (error) {
            console.error("OTP verification error:", error);
            toast.error("Something went wrong. Please try again.");
        }
    };

    const resendOtp = async () => {
        if (!canResendOtp) return;

        try {
            const generatedOtp = Math.floor(100000 + Math.random() * 900000);
            const tableSchema = "";
            const tableName = "users";

            const body = `Here's your MeddyList code again: ${generatedOtp}. Use it within 10 minutes. Need help? Reply to this message.`;

            const message = await sendSMS(phoneNumber, body);
            console.log("Twilio message response:", message);

            if (message.sid) {
                setResendOtpCount(60);
                setCanResendOtp(false);
                const data = {
                    otp: generatedOtp,
                    otp_expiry: new Date(Date.now() + 10 * 60000)
                };
                const condition = {
                    phone: tempUserData.phone
                };

                const updateResponse = await oneKlicks.update(tableSchema, tableName, data, condition);

                if (updateResponse.success) {
                    toast.success("New OTP sent to your phone number", { autoClose: 3000 });
                } else {
                    const tableSchema = "";
                    const tableName = "pharmacies";
                    const conditions = {
                        phone: tempUserData.phone
                    };
                    const orderBy = "id DESC";
                    const phoneLoginResponse = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, "", "", "");
                    if (phoneLoginResponse.data.length > 0) {
                        const user = phoneLoginResponse.data[0];
                        const generatedOtp = Math.floor(100000 + Math.random() * 900000);
                        const data = {
                            otp: generatedOtp,
                            otp_expiry: new Date(Date.now() + 10 * 60000)
                        };
                        const condition = {
                            phone: tempUserData.phone
                        };
                        const updateResponse = await oneKlicks.update(tableSchema, tableName, data, condition);
                        if (updateResponse.success) {
                            toast.success("New OTP sent to your phone number", { autoClose: 3000 });
                        }
                    } else {
                        toast.error("Failed to update OTP. Please try again.");
                    }
                }
            }
        } catch (error) {
            console.error("Resend OTP error:", error);
            toast.error("Failed to resend OTP. Please try again.");
        }
    };

    const handleLoginButton = (value) => {
        console.log("handleLoginButton run");
        setLoginbutton(value);
    };

    return (
        <>
            <Header setLoginbutton={handleLoginButton} isMobile={isMobile} />
            {children}
            {loginbutton && location.pathname !== '/login' && !isLoggedIn && (
                <div className="modal fade dc-loginformpop show" id="dc-loginpopup" style={{ display: 'block', paddingRight: '17px', background: '#00000085' }} aria-modal="true" role="dialog">
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="dc-modalcontent modal-content" style={{ width: '100%' }}>
                            <div className="dc-loginformholds">
                                <div className="dc-loginheader">
                                    <span>{showOtpForm ? 'Enter OTP' : 'Login'}</span>
                                    <a href="#" className="dc-closebtn close dc-close" onClick={() => {
                                        setLoginbutton(false);
                                        setShowOtpForm(false);
                                    }} aria-label="Close">
                                        <i className="fa fa-times"></i>
                                    </a>
                                </div>
                                {!showOtpForm ? (
                                    <>
                                        <div className="dc-login-tabs" style={{ marginLeft: '20px', marginTop: '10px' }}>
                                        </div>
                                        <form className="dc-formtheme dc-loginform do-login-form">
                                            <fieldset>
                                                {loginMethod === 'email' ? (
                                                    <>
                                                        <div className="form-group">
                                                            <input
                                                                type="email"
                                                                name="email"
                                                                value={email}
                                                                onChange={(e) => setEmail(e.target.value)}
                                                                className="form-control"
                                                                placeholder="Email"
                                                            />
                                                        </div>
                                                        <div className="form-group">
                                                            <input
                                                                type="password"
                                                                name="password"
                                                                className="form-control"
                                                                value={password}
                                                                onChange={(e) => setPassword(e.target.value)}
                                                                placeholder="Password"
                                                            />
                                                        </div>
                                                    </>
                                                ) : (
                                                    <PhoneInput
                                                        international
                                                        defaultCountry="IN"
                                                        value={phoneNumber}
                                                        onChange={setPhoneNumber}
                                                        placeholder="Enter phone number"
                                                        className="form-control frontend-phone-input"
                                                        style={{ paddingRight: '0px !important' }}
                                                    />
                                                )}
                                                <div className="dc-logininfo">

                                                    <input
                                                        type="submit"
                                                        className="dc-btn do-login-button"
                                                        onClick={(e) => loginbtn(e)}
                                                        value={loginMethod === 'email' ? 'Login' : 'Send OTP'}
                                                    />


                                                    {loginMethod === 'email' ? (
                                                        <a href="#" style={{ float: 'right' }}
                                                            className={`dc-btn do-login-button ${loginMethod === 'phone' ? 'active' : ''}`}
                                                            onClick={() => setLoginMethod('phone')}
                                                        >
                                                            Phone Login
                                                        </a>
                                                    ) : (
                                                        <a href="#" style={{ float: 'right' }}
                                                            className={`dc-btn do-login-button ${loginMethod === 'email' ? 'active' : ''}`}
                                                            onClick={() => setLoginMethod('email')}
                                                        >
                                                            Email Login
                                                        </a>

                                                    )}
                                                </div>
                                            </fieldset>
                                            <div className="dc-loginfooterinfo">
                                                <Link to="/forgot-password" className="dc-forgot-password" onClick={() => handleLoginButton(false)}>Forgot password?</Link>
                                                <Link to="/authentication">Create account</Link>
                                            </div>
                                        </form>
                                    </>
                                ) : (
                                    <form className="dc-formtheme dc-loginform do-login-form">
                                        <fieldset>
                                            <div className="form-group">
                                                <input
                                                    type="text"
                                                    name="otp"
                                                    value={otp}
                                                    onChange={(e) => setOtp(e.target.value)}
                                                    className="form-control"
                                                    placeholder="Enter 6-digit OTP"
                                                    maxLength="6"
                                                />
                                            </div>
                                            <div className="dc-logininfo">
                                                <input
                                                    type="submit"
                                                    className="dc-btn do-login-button"
                                                    onClick={verifyOtp}
                                                    value="Verify OTP"
                                                />
                                            </div>
                                        </fieldset>
                                        <p style={{ marginLeft: '20px' }}>Resend OTP {resendOtpCount > 0 ? `in ${resendOtpCount} seconds` : ''}</p>
                                        <div className="dc-loginfooterinfo">
                                            <a href="#" onClick={() => setShowOtpForm(false)}>Back to Login</a>
                                            <a href="#"
                                                onClick={resendOtp}
                                                className={`dc-forgot-password ${!canResendOtp ? 'disabled' : ''}`}
                                                style={{ opacity: canResendOtp ? 1 : 0.5, pointerEvents: canResendOtp ? 'auto' : 'none' }}
                                            >
                                                Resend OTP
                                            </a>
                                        </div>
                                    </form>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            )}
            <Footer />
            <ToastContainer position="top-right" autoClose={3000} />

        </>
    );
};

export default FrontendLayout;
